var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPowerpointFileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 10C3.33398 14.1421 6.6919 17.5 10.834 17.5C14.9761 17.5 18.334 14.1421 18.334 10H10.834H3.33398Z",
    fill: "#DC4C2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.834 2.5V10H18.334C18.334 5.85792 14.9761 2.5 10.834 2.5Z",
    fill: "#F7A278"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.834 2.5C6.6919 2.5 3.33398 5.85792 3.33398 10H10.834V2.5Z",
    fill: "#C06346"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29893 14.1663H2.36643C1.97977 14.1663 1.66602 13.8526 1.66602 13.4659V6.53342C1.66602 6.14676 1.97977 5.83301 2.36643 5.83301H9.29893C9.6856 5.83301 9.99935 6.14676 9.99935 6.53342V13.4659C9.99935 13.8526 9.6856 14.1663 9.29893 14.1663Z",
    fill: "#9B341F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1131 7.92188H4.16602V12.0885H5.00935V10.6215H5.95768C6.73935 10.6215 7.3731 9.98771 7.3731 9.20604V9.18188C7.3731 8.48604 6.80893 7.92188 6.1131 7.92188ZM6.48685 9.31604C6.48685 9.67396 6.19643 9.96438 5.83852 9.96438H5.00935V8.57896H5.83852C6.19643 8.57896 6.48685 8.86938 6.48685 9.22729V9.31604Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerpointFileLogo);
export default __webpack_public_path__ + "static/media/powerpointFile_logo.8a7609601d3b995b9ec40d6e66a75c8a.svg";
export { ForwardRef as ReactComponent };